import { css } from '@emotion/core';
import styled from '@emotion/styled';

import { SCREEN_SIZE } from '@shared/v2/constants';

import Link from '@/v2/components/ui/Link';

const WIDTH_OF_CAROUSEL_ACTIONS = 118;
const PADDING = 16;
export const TOTAL_ACTIONS_WIDTH = WIDTH_OF_CAROUSEL_ACTIONS + PADDING;

/*
  There are "action" buttons in the Carousel (Play, navigatable dots etc.),
  that are absolutely positioned on the _carousel layer_.
  The CTA does not know about this layer and must make adjustment in width if
  it is inside the Carousel (which it will be if the secondary campaign is active).
*/
export const PrimaryCTA = styled(Link.Button)`
  border: 2px solid white;
  height: 40px;
  padding: 0 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${({ isInCarousel }: { isInCarousel?: boolean }) => css`
    width: ${isInCarousel ? `calc(100% - ${TOTAL_ACTIONS_WIDTH}px)` : '100%'};
  `};

  &:hover {
    background: white;
    color: #e40000;
  }

  ${SCREEN_SIZE.MD} {
    width: fit-content;
  }

  ${SCREEN_SIZE.LG} {
    width: auto;
  }
`;

export const SecondaryCTA = styled(Link.Button)`
  border: 2px solid #e40000;
  background: white;
  color: #e40000;
  height: 40px;
  padding: 0 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: calc(100% - ${TOTAL_ACTIONS_WIDTH}px);

  &:hover {
    background: #e40000;
    color: white;
  }

  ${SCREEN_SIZE.MD} {
    width: fit-content;
  }

  ${SCREEN_SIZE.LG} {
    width: fit-content;
  }
`;
